import { useGetContactEntityActions } from '@apps-common/apis/portal/contact/get-contact-entity-actions'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { ContactActionsCard } from '@apps-common/components/modals/contact-actions/ContactActionsCard'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'

import { EndOfResults } from '../unit-history'

export const ContactActionsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: { entityId: string }
}) => {
  const { entityId } = componentProps
  const { data, isLoading, isError, refetch } = useGetContactEntityActions({
    entityId
  })

  const loading = isLoading || isError

  return (
    <ModalContainer innerClasses='!h-auto !min-h-0'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Action History' title='Contact actions' subtitleClasses='capitalize' />
          <ModalCloseButton closeModal={() => onDismiss(ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[100px] !pb-[10px]'>
        <PullRefresh loading={isLoading} callback={refetch} />
        <div className='grid gap-3'>
          {!loading && data?.length === 0 && <NoResultsCard text='No action results' classes='min-h-[100px]' />}
          {!loading && data && data.map((d) => <ContactActionsCard key={`action-card-${d.id}}`} action={d} />)}
          <EndOfResults show={!loading && !!data && data?.length > 0} />
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
